import { useRef, forwardRef, useImperativeHandle } from 'react';
import SignaturePad from 'react-signature-canvas';
import './SignatureCanvas.css';

export interface SignatureCanvasHandle {
  clear: () => void;
  isEmpty: () => boolean;
  toDataURL: () => string;
}

interface SignatureCanvasProps {
  onEnd?: () => void;
}

export const SignatureCanvas = forwardRef<SignatureCanvasHandle, SignatureCanvasProps>(
  ({ onEnd }, ref) => {
    const sigPadRef = useRef<SignaturePad>(null);

    useImperativeHandle(ref, () => ({
      clear: () => {
        sigPadRef.current?.clear();
      },
      isEmpty: () => {
        return sigPadRef.current?.isEmpty() ?? true;
      },
      toDataURL: () => {
        return sigPadRef.current?.toDataURL('image/png') ?? '';
      },
    }));

    return (
      <div className="signature-canvas-container">
        <SignaturePad
          ref={sigPadRef}
          canvasProps={{
            className: 'signature-pad',
            width: 600,
            height: 200,
          }}
          backgroundColor="rgb(255, 255, 255)"
          penColor="rgb(0, 0, 0)"
          onEnd={onEnd}
        />
      </div>
    );
  }
);

SignatureCanvas.displayName = 'SignatureCanvas';
